import React from 'react'
import { Route, IndexRoute } from 'react-router'
import { TRouteShowPage } from '../TRouteShowPage'
import { SendToDeviceV2Container } from '../SendToDeviceV2'

export const routes = (
  <Route>
    <Route path='send_to_device' component={SendToDeviceV2Container} />
    <IndexRoute component={TRouteShowPage} />
  </Route>
)
